
export default {
  formatQueryDate(data) {
    console.log('data', data)
    return JSON.parse(data)
  }
}
  